import React from 'react'

export const ProjectedTravelEmissionsIcon = (): JSX.Element => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.96086 23.9075C4.75347 23.9075 4.53311 23.8427 4.36461 23.7001C3.93687 23.3631 3.87206 22.7539 4.1961 22.3391L6.90517 20.0707C7.24218 19.6559 7.78658 19.0986 8.20136 19.4226C8.61615 19.7467 9.83457 18.9949 9.49756 19.4226L5.71265 23.5316C5.53118 23.7778 5.24602 23.9075 4.96086 23.9075Z"
      fill="#434343"
    />
    <path
      d="M19.245 23.9204C18.9598 23.9204 18.6746 23.7908 18.4802 23.5445L14.6823 19.4226C14.3453 18.9949 15.5638 19.7467 15.9786 19.4226C16.4063 19.0856 16.3026 19.0078 16.6267 19.4226L19.9838 22.352C20.3208 22.7798 20.243 23.389 19.8282 23.713C19.6597 23.8556 19.4523 23.9204 19.245 23.9204Z"
      fill="#434343"
    />
    <path
      d="M18.5968 20.8873H5.60897C4.00169 20.8873 2.69254 19.5782 2.69254 17.9709V3.58313C2.69254 1.97584 4.00169 0.666687 5.60897 0.666687H18.5968C20.2041 0.666687 21.5133 1.97584 21.5133 3.58313V17.9709C21.5133 19.5782 20.2041 20.8873 18.5968 20.8873ZM5.60897 2.61098C5.07753 2.61098 4.63683 3.05169 4.63683 3.58313V17.9709C4.63683 18.5023 5.07753 18.943 5.60897 18.943H18.5968C19.1283 18.943 19.569 18.5023 19.569 17.9709V3.58313C19.569 3.05169 19.1283 2.61098 18.5968 2.61098H5.60897Z"
      fill="#434343"
    />
    <path
      d="M20.5282 14.3934H3.63877C3.10733 14.3934 2.66663 13.9527 2.66663 13.4212C2.66663 12.8898 3.10733 12.4491 3.63877 12.4491H20.5282C21.0596 12.4491 21.5003 12.8898 21.5003 13.4212C21.5003 13.9527 21.0726 14.3934 20.5282 14.3934Z"
      fill="#434343"
    />
    <path
      d="M20.5282 6.78473H3.63877C3.10733 6.78473 2.66663 6.35698 2.66663 5.81258C2.66663 5.26818 3.10733 4.84044 3.63877 4.84044H20.5282C21.0596 4.84044 21.5003 5.28114 21.5003 5.81258C21.5003 6.34402 21.0726 6.78473 20.5282 6.78473Z"
      fill="#434343"
    />
    <path
      d="M8.49949 17.7376C9.04355 17.7376 9.4846 17.2965 9.4846 16.7525C9.4846 16.2084 9.04355 15.7674 8.49949 15.7674C7.95543 15.7674 7.51438 16.2084 7.51438 16.7525C7.51438 17.2965 7.95543 17.7376 8.49949 17.7376Z"
      fill="#434343"
    />
    <path
      d="M15.6804 17.7376C16.2245 17.7376 16.6655 17.2965 16.6655 16.7525C16.6655 16.2084 16.2245 15.7674 15.6804 15.7674C15.1364 15.7674 14.6953 16.2084 14.6953 16.7525C14.6953 17.2965 15.1364 17.7376 15.6804 17.7376Z"
      fill="#434343"
    />
  </svg>
)
